// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de langues modernes
// https://ifpc-fwb.be/v5/documents/tc/refLM.pdf
// SHA-256 72a6d2ba40db0fa4a56c42e508bca9d9894c3c28cc69005944eb121d61596e79
// P3: pages 28-32, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "LM-P3-8c7b5e0c",
    champ: "",
    section: "Savoirs lexicaux",
    kind: "Savoir",
    parent: "",
    text: "Représenter des mots et expressions de façon non verbale.",
  },
  {
    id: "LM-P3-f72fa88c",
    champ: "",
    section: "Savoirs lexicaux",
    kind: "Savoir",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Indiquer/reconnaitre des mots en lien avec un (sous-) champ thématique.",
  },
  {
    id: "LM-P3-d4bdd03c",
    champ: "",
    section: "Savoirs lexicaux",
    kind: "Savoir",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Citer des mots en lien avec un (sous-)champ thématique.",
  },
  {
    id: "LM-P3-175d646f",
    champ: "",
    section: "Savoirs lexicaux",
    kind: "Savoir",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Relier des mots à des représentations non verbales.",
  },
  {
    id: "LM-P3-b82f57c0",
    champ: "",
    section: "Savoirs lexicaux",
    kind: "Savoir",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Associer des mots entre eux en fonction d’une consigne donnée.",
  },
  {
    id: "LM-P3-b963d1ac",
    champ: "",
    section: "Savoir-faire lexicaux",
    kind: "Savoir-faire",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Classer/catégoriser des mots ou expressions en lien avec un (sous-)champ thématique.",
  },
  {
    id: "LM-P3-b75aae5c",
    champ: "",
    section: "Savoir-faire lexicaux",
    kind: "Savoir-faire",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Sélectionner les mots et expressions adéquats.",
  },
  {
    id: "LM-P3-54fd0ea1",
    champ: "",
    section: "Savoir-faire lexicaux",
    kind: "Savoir-faire",
    parent: "Répertoire élémentaire de mots et d’expressions relatifs aux champs thématiques de 3e année primaire (1, 3, 5, 6, 7, 8, 11 et 12). (cf. Annexe 1)",
    text: "Utiliser les mots et expressions adéquats.",
  },
  {
    id: "LM-P3-8b7333a3",
    champ: "",
    section: "Savoir-faire lexicaux",
    kind: "Savoir-faire",
    parent: "Combinaison de mots ou expressions relatives aux champs thématiques de 3e année primaire.",
    text: "Relier le signifiant et le signifié.",
  },
  {
    id: "LM-P3-d8aca773",
    champ: "",
    section: "Savoir-faire d’oralisation (tant en production qu’en réception)",
    kind: "Savoir-faire",
    parent: "Combinaison de mots ou expressions relatives aux champs thématiques de 3e année primaire.",
    text: "Prononcer correctement une expression ou un mot appris avec ou sans modèle.",
  },
  {
    id: "LM-P3-a84fe3da",
    champ: "",
    section: "Savoir-faire d’oralisation (tant en production qu’en réception)",
    kind: "Savoir-faire",
    parent: "Combinaison de mots ou expressions relatives aux champs thématiques de 3e année primaire.",
    text: "Identifier, à l’audition, une expression ou un mot appris.",
  },
  {
    id: "LM-P3-2aa34381",
    champ: "",
    section: "Savoir-faire d’oralisation (tant en production qu’en réception)",
    kind: "Savoir-faire",
    parent: "• Prononciation. • Intonation.",
    text: "Identifier l’intonation du message (affirmation, exclamation, interrogation).",
  },
  {
    id: "LM-P3-12115e1a",
    champ: "",
    section: "Savoir-faire d’oralisation (tant en production qu’en réception)",
    kind: "Savoir-faire",
    parent: "• Prononciation. • Intonation.",
    text: "Adopter une intonation au service de l’intention de communication.",
  },
  {
    id: "LM-P3-c56a9e99",
    champ: "",
    section: "Savoir-faire stratégiques",
    kind: "Savoir-faire",
    parent: "• Prononciation. • Intonation.",
    text: "Exploiter des indices linguistiques, visuels, auditifs.",
  },
  {
    id: "LM-P3-63818c26",
    champ: "",
    section: "Savoir-faire stratégiques",
    kind: "Savoir-faire",
    parent: "• Stratégies liées à la production orale : - planifier, exécuter, manifester sa (non-) compréhension, remédier à d’éventuelles incompréhensions.",
    text: "Identifier le type de support et ses caractéristiques principales.",
  },
  {
    id: "LM-P3-a7054d90",
    champ: "",
    section: "Savoir-faire stratégiques",
    kind: "Savoir-faire",
    parent: "• Stratégies liées à la production orale : - planifier, exécuter, manifester sa (non-) compréhension, remédier à d’éventuelles incompréhensions.",
    text: "Identifier les informations essentielles dans la consigne.",
  },
  {
    id: "LM-P3-8ab78d66",
    champ: "",
    section: "Savoir-faire stratégiques",
    kind: "Savoir-faire",
    parent: "• Stratégies liées à la réception : - cadrer, formuler des hypothèses, vérifier les hypothèses, réviser les hypothèses. Pour plus de détails, cf. Annexe 3.",
    text: "Discriminer les sons.",
  },
  {
    id: "LM-P3-f5439819",
    champ: "",
    section: "Savoir-faire stratégiques",
    kind: "Savoir-faire",
    parent: "• Stratégies liées à la réception : - cadrer, formuler des hypothèses, vérifier les hypothèses, réviser les hypothèses. Pour plus de détails, cf. Annexe 3.",
    text: "Associer le non-verbal au sens du verbal.",
  },
  {
    id: "LM-P3-9cd6397b",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler pour informer.",
    text: "Production orale très courte et simple : • pour se présenter ; • constituée de mots isolés, de mots internationalement partagés et d’expressions toutes faites.",
  },
  {
    id: "LM-P3-1f378db8",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler pour informer.",
    text: "Cette production orale : • respecte les caractéristiques reprises dans l’annexe 3 pour le niveau et l’année visés.",
  },
  {
    id: "LM-P3-0c927123",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler pour informer.",
    text: "Adaptation du comportement et/ou de la formulation du message par le recours à des marqueurs sociolinguistiques, en lien avec le contexte socioculturel, afin de garantir une communication qui respecte l’interlocuteur.",
  },
  {
    id: "LM-P3-0b3bdb20",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler en interaction pour informer.",
    text: "Production orale très courte et simple : • pour informer ; • constituée de mots isolés, de mots internationalement partagés et d’expressions toutes faites.",
  },
  {
    id: "LM-P3-611baeb7",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler en interaction pour informer.",
    text: "Cette production orale : • prend la forme : - de réponses adéquates à des questions ; - de formules de politesse et de salutations. • respecte les caractéristiques reprises dans l’annexe 3 pour le niveau et l’année visés.",
  },
  {
    id: "LM-P3-0c927123-2",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • parler en interaction pour informer.",
    text: "Adaptation du comportement et/ou de la formulation du message par le recours à des marqueurs sociolinguistiques, en lien avec le contexte socioculturel, afin de garantir une communication qui respecte l’interlocuteur.",
  },
  {
    id: "LM-P3-9f7bdd08",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • écouter un message19 pour s’informer ;",
    text: "Production verbale (orale ou écrite en français) ou non verbale, qui témoigne de l’identification de quelques informations pertinentes par rapport à la tâche, au travers, par exemple, d’un dessin, un schéma, une liste, un mime, un ou plusieurs mots.",
  },
  {
    id: "LM-P3-f5aa074c",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "• écouter un message pour agir ;",
    text: "Production verbale (orale ou écrite en français) ou non verbale, qui témoigne de l’identification de quelques informations pertinentes par rapport à l’action à poser. Action en exécution d’une consigne au travers, par exemple, d’un mouvement, d’une manipulation d’objet, d’un geste, d’un déplacement qui témoigne de la compréhension de l’injonction.",
  },
  {
    id: "LM-P3-36ff7cf6",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "• écouter un message pour prendre conscience de sa culture et s’ouvrir aux autres cultures.",
    text: "Repérage d’un ou de quelques éléments qui témoignent, par exemple, du patrimoine, de traditions ou de modes de vie.",
  },
  {
    id: "LM-P3-9f7bdd08-2",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • lire un message20 pour s’informer ;",
    text: "Production verbale (orale ou écrite en français) ou non verbale, qui témoigne de l’identification de quelques informations pertinentes par rapport à la tâche, au travers, par exemple, d’un dessin, un schéma, une liste, un mime, un ou plusieurs mots.",
  },
  {
    id: "LM-P3-e17fa6a7",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "Intention de communication : • lire un message20 pour s’informer ;",
    text: "Production verbale (orale ou écrite en français) ou non verbale, qui témoigne de l’identification de quelques informations pertinentes par rapport à l’action à poser.",
  },
  {
    id: "LM-P3-11e15dfe",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "• lire un message pour agir ;",
    text: "Action en exécution d’une consigne au travers, par exemple, d’un mouvement, d’une manipulation d’objet, d’un geste, d’un déplacement qui témoigne de la compréhension de l’injonction.",
  },
  {
    id: "LM-P3-36ff7cf6-2",
    champ: "",
    section: "Niveau du CECRL en 3e primaire : sensibilisation pré-A1 (rien à l’écrit)",
    kind: "Compétence",
    parent: "• lire un message pour agir ;",
    text: "Repérage d’un ou de quelques éléments qui témoignent, par exemple, du patrimoine, de traditions ou de modes de vie.",
  },
];
